import styled from 'styled-components'

export const Emphasis = styled.span`
  font-weight: ${({ theme }) => theme.font.weight.semibold};
`
